import { ActionEventAction, ElementEventAction } from '@user-portal/wikr-analytics';

import { trackClick } from './mainTrackers';

export const sendAnalyticDownloadGuideClick = (guideName: string) => {
  trackClick({
    elementEvent: ElementEventAction.guide,
    actionEvent: ActionEventAction.download,
    eventLabel: guideName,
  });
};
